import { insertWordBreaks } from '@/_utils/utils';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { selectJobDeliverables } from '@/redux/selectors/jobSelectors';
import { Deliverable } from '@/redux/slices/slice_types';
import styled from '@emotion/styled';
import { Box, Fade, Grid, Typography } from '@mui/material';
import ClickCopy from '../../../_common/ClickCopy/ClickCopy';
import AssetIcon from './AssetIcon';
import { useAppSelector } from '@/redux/hooks';

const JobDeliverables = () => {
  const deliverables = useAppSelector(selectJobDeliverables);

  return (
    <Box sx={{ mb: 3, mt: -2, width: '100%' }}>
      {deliverables?.length ? (
        deliverables.map((deliverable: Deliverable, i: number) => (
          <Fade key={`deliverable_${deliverable.order}_${i}`} in timeout={(i + 1) * 300}>
            <div>
              <ClickCopy copyText={deliverable.name} placement="left">
                <Grid container alignItems="center" flexWrap="nowrap">
                  <DeliverableIcon>
                    <AssetIcon type={deliverable.type} height={20} />
                  </DeliverableIcon>
                  <div>{insertWordBreaks(deliverable.name)}</div>
                </Grid>
              </ClickCopy>
            </div>
          </Fade>
        ))
      ) : (
        <Grid container alignItems="center" sx={{ opacity: 0.5 }}>
          <Grid item sx={{ mr: 0.75, height: 20, opacity: 0.7 }}>
            <PolarisIcon icon="pending_actions" height={20} />
          </Grid>
          <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
            Filename not yet generated
          </Typography>
        </Grid>
      )}
    </Box>
  );
};

export default JobDeliverables;

const DeliverableIcon = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 0.5rem;
  & > div {
    border: 0;
    background: none;
    width: 24px;
    min-width: 24px;
    padding: 0;
    margin: 0;
    height: 24px;
  }
`;
